document.addEventListener("DOMContentLoaded", function () {
  const wizard = document.getElementById("wizard");
  if (!wizard) return;

  const steps = Array.from(wizard.querySelectorAll(".step"));
  const result = document.getElementById("builder-result");
  const summary = document.getElementById("product-summary");
  const addKitButton = document.getElementById("add-kit");
  const progressFill = document.querySelector(".mag-progress-fill");
  const progressText = document.querySelector(".mag-progress-text");

  const products = window.magnetonesProducts || {};
  const settings = window.magSettings || {};
  const animationStyle = settings.animation || "none";
  const animationSpeed = Number(settings.speed || 0);

  const state = {
    sax: null,
    backing: null,
    type: null,
    reso1: null,
    wantsSecond: null,
    reso2: null
  };

  let currentStep = 1;
  let builtCart = [];

  function visibleStepCount() {
    return state.wantsSecond === "yes" ? 6 : 5;
  }

  function progressIndexFor(stepNumber) {
    return Math.min(stepNumber, visibleStepCount());
  }

  function updateProgress(stepNumber) {
    const total = visibleStepCount();
    const current = progressIndexFor(stepNumber);
    const percent = (current / total) * 100;

    if (progressFill) progressFill.style.width = percent + "%";
    if (progressText) progressText.textContent = `Step ${current} of ${total}`;
  }

  function clearSelected(stepEl) {
    stepEl.querySelectorAll("button[data-value]").forEach((btn) => {
      btn.classList.remove("selected");
    });
  }

  function hideAllSteps() {
    steps.forEach((step) => {
      step.classList.remove("active");
      step.style.display = "none";
      step.style.opacity = "";
      step.style.transform = "";
    });
  }

  function showResult() {
    hideAllSteps();
    wizard.style.display = "block";
    result.style.display = "block";
    result.style.opacity = "1";
    result.style.transform = "none";
    updateProgress(visibleStepCount());
  }

  function hideResult() {
    result.style.display = "none";
  }

  function animateIn(el) {
    if (animationStyle === "none" || animationSpeed === 0) {
      el.style.display = "block";
      el.classList.add("active");
      return;
    }

    el.style.display = "block";
    el.classList.add("active");

    if (animationStyle === "fade") {
      el.style.opacity = "0";
      requestAnimationFrame(() => {
        el.style.transition = `opacity ${animationSpeed}ms ease`;
        el.style.opacity = "1";
      });
      return;
    }

    if (animationStyle === "slide") {
      el.style.opacity = "0";
      el.style.transform = "translateX(18px)";
      requestAnimationFrame(() => {
        el.style.transition = `opacity ${animationSpeed}ms ease, transform ${animationSpeed}ms ease`;
        el.style.opacity = "1";
        el.style.transform = "translateX(0)";
      });
    }
  }

  function showStep(stepNumber) {
    currentStep = stepNumber;
    hideResult();
    hideAllSteps();

    const stepEl = wizard.querySelector(`.step[data-step="${stepNumber}"]`);
    if (!stepEl) return;

    animateIn(stepEl);
    updateProgress(stepNumber);
  }

  function resetWizard() {
    state.sax = null;
    state.backing = null;
    state.type = null;
    state.reso1 = null;
    state.wantsSecond = null;
    state.reso2 = null;
    builtCart = [];
    summary.innerHTML = "";

    steps.forEach((step) => clearSelected(step));

    showStep(1);
  }

  function calculateCounts() {
    if (state.sax === "soprano") {
      return { large: 0, small: 3 };
    }

    if (state.sax === "alto" || state.sax === "tenor") {
      return { large: 2, small: 1 };
    }

    if (state.sax === "baritone") {
      return { large: 3, small: 0 };
    }

    return { large: 0, small: 0 };
  }

  function addSummaryItem(product, qty, fallbackTitle) {
    const li = document.createElement("li");
    li.className = "mag-item";

    const img = product && product.image
      ? `<img src="${product.image}" class="mag-thumb" alt="">`
      : "";

    const title = (product && product.title) || fallbackTitle || "Product";

    li.innerHTML = `
      ${img}
      <div>
        <strong>${title}</strong><br>
        Qty ${qty}
      </div>
    `;

    summary.appendChild(li);
  }

  function buildKit() {
    summary.innerHTML = "";
    builtCart = [];

    const counts = calculateCounts();

    if (state.backing === "no") {
      if (counts.large > 0 && products.largeBacking?.id) {
        builtCart.push({ id: products.largeBacking.id, quantity: counts.large });
        addSummaryItem(products.largeBacking, counts.large, "Large Backing Magnets");
      }

      if (counts.small > 0 && products.smallBacking?.id) {
        builtCart.push({ id: products.smallBacking.id, quantity: counts.small });
        addSummaryItem(products.smallBacking, counts.small, "Small Backing Magnets");
      }
    }

    if (counts.large > 0 && products.largeResonator?.id) {
      builtCart.push({ id: products.largeResonator.id, quantity: counts.large });
      addSummaryItem(products.largeResonator, counts.large, "Large Resonator Magnet Set");
    }

    if (counts.small > 0 && products.smallResonator?.id) {
      builtCart.push({ id: products.smallResonator.id, quantity: counts.small });
      addSummaryItem(products.smallResonator, counts.small, "Small Resonator Magnet Set");
    }
  }

  function finishWizard() {
    buildKit();
    showResult();
  }

  function handleAnswer(stepNumber, value, button) {
    const stepEl = button.closest(".step");
    if (!stepEl) return;

    clearSelected(stepEl);
    button.classList.add("selected");

    if (stepNumber === 1) {
      state.sax = value;
      showStep(2);
      return;
    }

    if (stepNumber === 2) {
      state.backing = value;
      showStep(3);
      return;
    }

    if (stepNumber === 3) {
      state.type = value;
      showStep(4);
      return;
    }

    if (stepNumber === 4) {
      state.reso1 = value;
      showStep(5);
      return;
    }

    if (stepNumber === 5) {
      state.wantsSecond = value;

      if (value === "yes") {
        showStep(6);
      } else {
        state.reso2 = null;
        finishWizard();
      }
      return;
    }

    if (stepNumber === 6) {
      state.reso2 = value;
      finishWizard();
    }
  }

  function goBack() {
    hideResult();

    if (currentStep === 1) return;

    if (currentStep === 2) {
      showStep(1);
      return;
    }

    if (currentStep === 3) {
      showStep(2);
      return;
    }

    if (currentStep === 4) {
      showStep(3);
      return;
    }

    if (currentStep === 5) {
      showStep(4);
      return;
    }

    if (currentStep === 6) {
      showStep(5);
      return;
    }
  }

  wizard.querySelectorAll("button[data-value]").forEach((button) => {
    button.addEventListener("click", function () {
      const stepEl = this.closest(".step");
      if (!stepEl) return;

      const stepNumber = Number(stepEl.dataset.step);
      const value = this.dataset.value;

      handleAnswer(stepNumber, value, this);
    });
  });

  document.querySelectorAll(".mag-back").forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      goBack();
    });
  });

  document.querySelectorAll(".mag-reset").forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      resetWizard();
    });
  });

  if (addKitButton) {
    addKitButton.addEventListener("click", async function () {
      if (!builtCart.length) return;

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: builtCart })
        });

        if (!res.ok) {
          const text = await res.text();
          console.error("Cart add failed:", text);
          alert("Could not add the kit to cart. Check your product selections in the theme editor.");
          return;
        }

        window.location.href = "/cart";
      } catch (err) {
        console.error("Cart add error:", err);
        alert("Could not add the kit to cart.");
      }
    });
  }

  hideResult();
  showStep(1);
});